import React  from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Panel from "../Panel";
import { panel } from "./actionPanelStyles.module.scss";

const LegacyActionPanel = ({ children, className }) => (
  <Panel className={classNames(panel, className)}>
    <div className="container">
      <div className="row">
        {children}
      </div>
    </div>
  </Panel>
);

LegacyActionPanel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

LegacyActionPanel.defaultProps = {
  children: null,
  className: null
};

export default LegacyActionPanel;
